import { render, staticRenderFns } from "./EducationFullScreen.vue?vue&type=template&id=7e9326a4&scoped=true&"
import script from "./EducationFullScreen.vue?vue&type=script&lang=js&"
export * from "./EducationFullScreen.vue?vue&type=script&lang=js&"
import style0 from "./EducationFullScreen.vue?vue&type=style&index=0&id=7e9326a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9326a4",
  null
  
)

export default component.exports